(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["list-filter"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('facet-search-component')) {
    customElements.define(
      'facet-search-component',
      class FacetSearchComponent extends HTMLElement {
        connectedCallback() {
          this.input = this.querySelector('.facets__search-input');
          this.clearButton = this.querySelector('.facets__search-clear');
          this.noResults = this.querySelector('.facets__search-no-results');
          this.list = this.parentElement ? this.parentElement.querySelector('.facets__inputs-list') : null;
          this.showMore = this.closest('show-more-component');

          if (!this.input || !this.list) return;

          this.input.addEventListener('input', this.filterList.bind(this));
          if (this.clearButton) {
            this.clearButton.addEventListener('click', () => {
              this.input.value = '';
              this.filterList();
              this.input.focus();
            });
          }
        }

        filterList() {
          var query = this.input.value.trim().toLowerCase();

          if (this.clearButton) this.clearButton.hidden = query === '';

          if (query && this.showMore && this.showMore.dataset.expanded === 'false') {
            var expandButton = this.showMore.querySelector('[ref="showMoreButton"]');
            if (expandButton) expandButton.click();
          }

          var visibleCount = 0;
          this.list.querySelectorAll('.facets__inputs-list-item').forEach(function (item) {
            var matches = query === '' || item.textContent.trim().toLowerCase().indexOf(query) !== -1;
            item.classList.toggle('facets__inputs-list-item--search-hidden', !matches);
            if (matches) visibleCount += 1;
          });

          if (this.noResults) this.noResults.classList.toggle('hidden', visibleCount !== 0);
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pf-product-specs"] && !Shopify.designMode) return;
  try {
    (function () {
    document.querySelectorAll('[data-pf-desc]').forEach(function (card) {
      var content = card.querySelector('[data-pf-desc-content]');
      var toggle = card.querySelector('[data-pf-desc-toggle]');
      var label = card.querySelector('[data-pf-desc-more-label]');
      if (!content || !toggle || !label) return;

      // Only the current, real overflow decides whether "Read more" shows at
      // all — not just whether a line-count setting is non-zero. Re-checked on
      // resize since desktop/mobile can have different limits, so crossing the
      // breakpoint can flip whether this description is actually clamped.
      function updateClamped() {
        var wasExpanded = card.hasAttribute('data-expanded');
        if (wasExpanded) card.removeAttribute('data-expanded');

        var overflowing = content.scrollHeight - content.clientHeight > 1;
        card.classList.toggle('pf-pspecs__desc--clamped', overflowing);

        if (wasExpanded) card.setAttribute('data-expanded', '');
      }

      var resizeTimer;
      window.addEventListener('resize', function () {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(updateClamped, 150);
      });
      window.addEventListener('load', updateClamped);
      updateClamped();

      toggle.addEventListener('click', function () {
        var expanded = card.hasAttribute('data-expanded');
        if (expanded) {
          card.removeAttribute('data-expanded');
          label.textContent = label.dataset.moreText;
          toggle.setAttribute('aria-expanded', 'false');
        } else {
          card.setAttribute('data-expanded', '');
          label.textContent = label.dataset.lessText;
          toggle.setAttribute('aria-expanded', 'true');
        }
      });
    });
  }());
  } catch(e) { console.error(e); }
})();

})();
